import fileDownload from 'js-file-download';
import moment from 'moment';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import React from 'react';
import { Trans } from 'react-i18next';

import { Icon } from '@shared/ui/components/Icon';
import { Tooltip } from '@shared/ui/components/Tooltip';

import Confirm from '../../../base/Confirm';
import ListView from '../../../base/ListView';
import { toImmutable } from '../../../libs/immutable-transformer';
import { ajaxErrorHandler, defaultSuccess, formatUTCDate } from '../../../libs/utils';
import { downloadInstance } from '../../../services/api';
import { getCompanies } from '../../../services/api/companies';
import { getGates } from '../../../services/api/gates';
import { getRegistration } from '../../../services/api/registrations';
import {
  approveTransportRequest,
  deleteTransportRequest,
  getAllTransportRequests,
  getTransportRequests,
  pendTransportRequest,
  rejectTransportRequest,
} from '../../../services/api/transportRequests';
import { sendTransportVoucher } from '../../../services/api/transportVouchers';
import ReportDownloadButton from '../../admin/reporting/exports/ReportDownloadButton';
import CreateGatekeepingRequestButton from '../../shared/gatekeeping/CreateGatekeepingRequestButton';

class GatekeepingOverview extends React.Component {
  constructor(props) {
    super(props);

    const parsedFilters = queryString.parse(window.location.search);
    const baseFilters = {
      'include': props.admin ? 'location,location.gate,registration,registration.company' : 'location,location.gate',
      'filter[event_id]': props.admin ? props.event.id : '',
      ...parsedFilters,
    };

    this.state = {
      requests: [],
      requestsMeta: {},
      loaded: false,
      baseFilters: toImmutable(baseFilters),
      gates: [],
      locations: [],
    };

    this._getRequests = this._getRequests.bind(this);
    this._handleDelete = this._handleDelete.bind(this);
    this._handleFilterUpdate = this._handleFilterUpdate.bind(this);
    this._getLocations = this._getLocations.bind(this);
    this._approveRejectBtns = this._approveRejectBtns.bind(this);
    this._approve = this._approve.bind(this);
    this._reject = this._reject.bind(this);
    this._pend = this._pend.bind(this);
    this._gatesToLocations = this._gatesToLocations.bind(this);
    this._sendVoucher = this._sendVoucher.bind(this);
    this._downloadVoucher = this._downloadVoucher.bind(this);
  }

  static propTypes = {
    registration: PropTypes.object,
    event: PropTypes.object,
    admin: PropTypes.bool,
  };

  UNSAFE_componentWillMount() {
    this._getRequests();
    this._getLocations();
  }

  _getLocations() {
    if (this.props.admin) {
      getGates(this.props.event.id, {
        include: 'locations',
      }).then((response) => {
        this._gatesToLocations(response.data);
        this.setState({
          gates: response.data,
        });
      });
    } else {
      getRegistration(this.props.registration.id, {
        include: 'event,event.gates,event.gates.locations',
      }).then((response) => {
        this._gatesToLocations(response.event.gates);
        this.setState({
          gates: response.event.gates,
        });
      });
    }
  }

  _gatesToLocations(gates) {
    let locations = [];

    gates.forEach((gate) => {
      gate.locations.forEach((location) => {
        locations.push({
          ...location,
          gate: {
            name: gate.name,
          },
        });
      });
    });

    this.setState({
      locations,
    });
  }

  _getRequests(filters = this.state.baseFilters) {
    if (this.props.admin) {
      getAllTransportRequests(filters).then((response) => {
        this.setState({
          requests: response.data,
          requestsMeta: response.meta,
          loaded: true,
          baseFilters: filters,
        });
      });
    } else {
      getTransportRequests(this.props.registration.id, filters).then((response) => {
        this.setState({
          requests: response.data,
          requestsMeta: response.meta,
          loaded: true,
          baseFilters: filters,
        });
      });
    }
  }

  _downloadVoucher(item) {
    let url;
    if (this.props.admin) {
      url = `registrations/${item.registrationId}/transport-requests/${item.id}/download-voucher`;
    } else {
      url = `registrations/${this.props.registration.id}/transport-requests/${item.id}/download-voucher`;
    }

    downloadInstance({
      method: 'get',
      url,
      responseType: 'blob',
    })
      .then((response) => {
        fileDownload(response.data, 'transportvoucher' + moment().format('DD-MM-YYY-HH-mm-ss') + '.pdf');
      })
      .catch(ajaxErrorHandler);
  }

  _handleDelete(id) {
    Confirm('Are you sure you want to delete this Transport Request?', {
      title: 'Delete Transport Request',
      confirmStyle: 'btn-danger',
      confirmText: 'Delete',
    }).then(
      (result) => {
        if (this.props.admin) {
          const request = this.state.requests.filter((request) => request.id === id)[0];
          deleteTransportRequest(request.registrationId, id).then((response) => this._getRequests());
        } else {
          deleteTransportRequest(this.props.registration.id, id).then((response) => this._getRequests());
        }
      },
      (result) => {}
    );
  }

  _handleFilterUpdate(filters) {
    this._getRequests(filters);
    this.setState({
      filtered: true,
    });
  }

  _approveRejectBtns(item) {
    if (!this.props.admin) {
      return (
        <span>
          <button
            className="btn btn-outline-success m-btn btn-sm  m-btn--icon m--margin-left-5"
            onClick={() => this._downloadVoucher(item)}
          >
            <span>
              <i className="la la-download" />
              <span>Download Voucher</span>
            </span>
          </button>
          <button
            className="btn btn-outline-info m-btn btn-sm  m-btn--icon m--margin-left-5"
            onClick={() => this._sendVoucher(item)}
          >
            <span>
              <i className="la la-send" />
              <span>Resend Voucher</span>
            </span>
          </button>
        </span>
      );
    } else {
      return (
        <span>
          {item.status === 'approved' && (
            <span>
              <span>
                <button
                  className="btn btn-outline-success m-btn btn-sm  m-btn--icon m--margin-left-5"
                  onClick={() => this._downloadVoucher(item)}
                >
                  <span>
                    <i className="la la-download" />
                    <span>Download Voucher</span>
                  </span>
                </button>
              </span>
              <span>
                <button
                  className="btn btn-outline-info m-btn btn-sm  m-btn--icon m--margin-left-5"
                  onClick={() => this._sendVoucher(item)}
                >
                  <span>
                    <i className="la la-send" />
                    <span>Resend Voucher</span>
                  </span>
                </button>
              </span>
            </span>
          )}
          {item.status === 'pending' && (
            <span key="approve">
              <button
                className="btn btn-outline-success m-btn btn-sm  m-btn--icon m--margin-left-5"
                onClick={() => this._approve(item)}
              >
                <span>
                  <i className="la la-check" />
                  <span>Approve</span>
                </span>
              </button>
            </span>
          )}

          {item.status === 'rejected' && (
            <span key="approve">
              <button
                className="btn btn-outline-metal m-btn btn-sm  m-btn--icon m--margin-left-5"
                onClick={() => this._pend(item)}
              >
                <span>
                  <i className="la la-check" />
                  <span>Set to Pending</span>
                </span>
              </button>
            </span>
          )}

          {(item.status === 'pending' || item.status === 'approved') && (
            <span key="reject">
              <button
                className="btn btn-outline-danger m-btn btn-sm  m-btn--icon m--margin-left-5"
                onClick={() => this._reject(item)}
              >
                <span>
                  <i className="la la-close" />
                  <span>Reject</span>
                </span>
              </button>
            </span>
          )}
        </span>
      );
    }
  }

  _approve(item) {
    approveTransportRequest(item.registrationId, item.id)
      .then((response) => {
        this._getRequests();
        defaultSuccess('Request has been approved');
      })
      .catch(ajaxErrorHandler);
  }

  _reject(item) {
    rejectTransportRequest(item.registrationId, item.id)
      .then((response) => {
        this._getRequests();
        defaultSuccess('Request has been rejected');
      })
      .catch(ajaxErrorHandler);
  }

  _pend(item) {
    pendTransportRequest(item.registrationId, item.id)
      .then((response) => {
        this._getRequests();
        defaultSuccess('Request has been set to Pending');
      })
      .catch(ajaxErrorHandler);
  }

  _sendVoucher(item) {
    sendTransportVoucher(item.registrationId, item.id)
      .then((response) => {
        defaultSuccess('Voucher send');
      })
      .catch(ajaxErrorHandler);
  }

  render() {
    const { requests, requestsMeta, loaded, baseFilters, locations, gates } = this.state;
    const { registration, event, admin } = this.props;

    const filters = [
      {
        col: 8,
        label: 'Driver',
        icon: 'la-search',
        type: 'text',
        key: 'driver_name',
      },
      {
        col: 4,
        label: 'License plate',
        icon: 'la-search',
        type: 'text',
        key: 'license_plate',
      },
      {
        col: 4,
        label: 'Location',
        icon: 'la-map-marker',
        type: 'select',
        key: 'location_id',
        dataset: locations.map((location) => {
          return { key: location.id, value: location.name };
        }),
      },
      {
        col: 4,
        label: 'Status',
        icon: 'la-tag',
        type: 'select',
        key: 'current_status',
        dataset: [
          { key: 'pending', value: 'Pending' },
          { key: 'approved', value: 'Approved' },
          { key: 'rejected', value: 'Rejected' },
        ],
      },
    ];

    const columns = [
      {
        key: 'driverName',
        value: 'Driver',
        sort: 'driver_name',
        render: (item) => (
          <>
            <strong>{item.driverName}</strong>
            {item.licensePlate ? ` (${item.licensePlate})` : ''}
            <br />
            <small>{item.driverTelephone}</small>
          </>
        ),
      },
      {
        key: 'location.name',
        value: 'Location',
        sort: 'location_id',
        render: (item) => (
          <>
            {item.location.name}
            <br />
            <small>via {item.location.gate.name}</small>
          </>
        ),
      },
      {
        key: 'transportAt',
        value: 'Date / Time',
        sort: 'transport_at',
        render: (item) =>
          item.allDay
            ? formatUTCDate(item.transportAt, 'ddd DD/MM/YY') + ' (all day)'
            : formatUTCDate(item.transportAt, 'ddd DD/MM/YY HH:mm'),
      },
      {
        key: 'status',
        value: 'Status',
        render: (request) => {
          switch (request.status) {
            case 'approved':
              return <div className="m-badge m-badge--success m-badge--wide">{request.status}</div>;
            case 'rejected':
              return <div className="m-badge m-badge--danger m-badge--wide">{request.status}</div>;
            default:
              return <div className="m-badge m-badge--metal m-badge--wide">{request.status}</div>;
          }
        },
      },
      {
        key: 'gateRequest',
        value: '',
        render: (request) => (
          <>
            {request.gateRequest && (
              <Tooltip content="Printed at gate">
                <Icon icon="print" />
              </Tooltip>
            )}
          </>
        ),
      },
    ];

    if (admin) {
      filters.push({
        col: 6,
        label: 'Company',
        icon: 'la-building',
        type: 'typeahead',
        options: (value) =>
          getCompanies({
            'filter[name]': value,
            'filter[registered_for_event_id]': registration.eventId,
          }),
        key: 'company_id',
        labelKey: 'name',
      });

      filters.push({
        col: 6,
        label: 'Gate',
        icon: 'la-tag',
        type: 'select',
        key: 'gate_name',
        dataset: gates.map((gate) => {
          return { key: gate.name, value: gate.name };
        }),
      });

      columns.unshift({
        key: 'company',
        value: 'Company',
        render: (request) => request.registration.company.name,
      });
    }

    const listViewConf = {
      dataSet: requests,
      dataMeta: requestsMeta,
      columns,
      filters,
      baseFilters: baseFilters,
      actions: {
        deleteLink: true,
        editLink: false,
        detailsLink: false,

        deleteFunction: this._handleDelete,
        customLink: this._approveRejectBtns,
      },
      url: '',
    };

    return (
      <div className="m-content">
        <div className="row">
          <div className="col-xl-12">
            <div className="m-portlet">
              <div className="m-portlet__head">
                <div className="m-portlet__head-caption">
                  <div className="m-portlet__head-title" />
                </div>

                <div className="m-portlet__head-tools">
                  <ul className="m-portlet__nav m--margin-left-20">
                    {admin && (
                      <li className="m-portlet__nav-item">
                        <ReportDownloadButton
                          report={{
                            downloadUrl:
                              'https://crew-api.tomorrowland.com/api/events/' +
                              event.id +
                              '/reporting/transport_requests',
                            name: 'transport_requests',
                          }}
                          event={event}
                        />
                      </li>
                    )}

                    <li className="m-portlet__nav-item">
                      <CreateGatekeepingRequestButton
                        registration={registration}
                        event={event}
                        refreshRequests={this._getRequests}
                        locations={locations}
                        admin={!!admin}
                      />
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                {loaded && requests && (
                  <ListView
                    config={listViewConf}
                    handleDelete={this._handleDelete}
                    handleFilterUpdate={this._handleFilterUpdate}
                  />
                )}

                {loaded && !requests && (
                  <div className="alert alert-info">
                    <Trans>frontend.crew.noRegistrationParkingRequestsMsg</Trans>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default GatekeepingOverview;
